export default "__VITE_ASSET__CodV7WzD__"